export default "__VITE_ASSET__5c4f8fe3__"